// extracted by mini-css-extract-plugin
export default {"container1":"Header_container1__5EBwd","item3":"Header_item3__HUqi8"};